export class NL_StokKarti {
ID:number;
Kodu:string;
StokAdi:string;
Barcode1:string;
Barcode2:string;
Vat:number;
KategoriID:number;
MarkId:number;
VatGrupId:number;
Price1:number;
Price2:number;
Price3:number;
Price4:number;
Status:number;
WebStatus:number;
BirimId:number;
Image1:string;
Image2:string;
IsTerazi:number;
PLU:number;
ParentAktif:number;
FiyatDegisimTarihi:string;
MaximumSeviye:number;
MinumumSeviye:number;
Hit:number;
EkranSiraNo:number;
Entegrasyon:number;
Guncellendi:number;
EkranNumarasi:number;
YerliMi:number;
UlkeID:number;
PuanAktif:number;
BagliStokID:number;

}



// WEBPACK FOOTER //
// ./src/models/NL_StokKarti.ts